/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../../services/Http';

// private sector
let $http;

//public sector
export default class AuthRepository {
    
    constructor($auth){
        $http = new Http($auth);        
    }

    loginEmployee(data){
        return $http.post("login/employee", data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
                return Promise.reject(response);
        });
    }

    forgotPassword(data){            
        return $http.post("forgot/password", data).then((response) => {                        
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    } 
       
    passwordReset(data){            
        return $http.post("password/reset", data).then((response) => {                        
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    }   
    
    confirmEmail(token){            
        return $http.get("email/confirmation/" + token).then((response) => {                        
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    }        
   
}